module.exports = __webpack_public_path__ + "static/media/warehouse_icon.df46085c.svg";